export const CONSENT_KEY = "topgeo_cookie_consent_v1";
export const CONSENT_EVENT = "topgeo:consent-changed";
export const CONSENT_MAX_AGE = 180 * 24 * 60 * 60 * 1000;
export type Consent = { analytics: boolean; marketing: boolean; savedAt: number };

export function readConsent(): Consent | null {
  try {
    const value = JSON.parse(window.localStorage.getItem(CONSENT_KEY) || "null");
    if (!value || typeof value.analytics !== "boolean" || typeof value.marketing !== "boolean" ||
      typeof value.savedAt !== "number" || value.savedAt > Date.now() ||
      Date.now() - value.savedAt >= CONSENT_MAX_AGE) return null;
    return value;
  } catch {
    return null;
  }
}

export function saveConsent(analytics: boolean, marketing: boolean): boolean {
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify({ analytics, marketing, savedAt: Date.now() }));
    window.dispatchEvent(new Event(CONSENT_EVENT));
    return true;
  } catch {
    return false;
  }
}
